(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["notifications"] && !Shopify.designMode) return;
  try {
    class NotificationsList extends HTMLElement {
    static tagName = 'notifications-list';
    static storageKey = 'seenNotifications';
    static {
      customElements.define(NotificationsList.tagName, NotificationsList);
    }

    /** @type {IntersectionObserver|null} */
    #observer = null;

    /**
     * Gets all notification item elements
     * @returns {NodeListOf<HTMLElement>}
     */
    get #items() {
      return this.querySelectorAll('.notifications-list__item');
    }

    connectedCallback() {
      this.#pruneStaleNotifications();
      this.#checkForUnseenNotifications();
      this.#setupIntersectionObserver();
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
    }

    /**
     * Gets all notification IDs from the DOM
     * @returns {string[]}
     */
    #getNotificationIds() {
      return Array.from(this.#items).map((item) => item.id.replace('notification-', ''));
    }

    /**
     * Gets the set of seen notification IDs from localStorage
     * @returns {Set<string>}
     */
    #getSeenNotifications() {
      try {
        const stored = localStorage.getItem(NotificationsList.storageKey);
        return new Set(stored ? JSON.parse(stored) : []);
      } catch {
        return new Set();
      }
    }

    /**
     * Saves seen notifications to localStorage
     * @param {Set<string>} seen
     */
    #saveSeenNotifications(seen) {
      try {
        localStorage.setItem(NotificationsList.storageKey, JSON.stringify([...seen]));
      } catch {
        // Storage full or unavailable
      }
    }

    /**
     * Removes notification IDs from storage that no longer exist in the DOM
     */
    #pruneStaleNotifications() {
      const currentIds = new Set(this.#getNotificationIds());
      const seen = this.#getSeenNotifications();
      const pruned = new Set([...seen].filter((id) => currentIds.has(id)));

      if (pruned.size !== seen.size) {
        this.#saveSeenNotifications(pruned);
      }
    }

    /**
     * Checks if there are unseen notifications and adds the 'has-unseen' class
     */
    #checkForUnseenNotifications() {
      const seen = this.#getSeenNotifications();
      const hasUnseen = this.#getNotificationIds().some((id) => !seen.has(id));
      this.classList.toggle('has-unseen', hasUnseen);
    }

    /**
     * Sets up IntersectionObserver to mark all notifications as seen when the list is visible
     */
    #setupIntersectionObserver() {
      this.#markSeenNotifications();

      this.#observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            this.#markAllAsSeen();
            this.#observer?.disconnect();
          });
        },
        { threshold: 0.1 }
      );

      this.#observer.observe(this);
    }

    /**
     * Adds '--seen' modifier to all notifications that have been seen
     */
    #markSeenNotifications() {
      const seen = this.#getSeenNotifications();

      this.#items.forEach((item) => {
        const id = item.id.replace('notification-', '');
        if (seen.has(id)) {
          item.classList.add('notifications-list__item--seen');
        }
      });
    }

    /**
     * Marks all notifications as seen and updates the UI
     */
    #markAllAsSeen() {
      const seen = this.#getSeenNotifications();
      const notificationIds = this.#getNotificationIds();

      notificationIds.forEach((id) => seen.add(id));
      this.#saveSeenNotifications(seen);

      setTimeout(() => {
        this.#items.forEach((item) => {
          item.classList.add('notifications-list__item--seen');
        });

        this.#updateUnseenState();
      }, 3000);
    }

    /**
     * Updates the has-unseen class based on current state
     */
    #updateUnseenState() {
      const seen = this.#getSeenNotifications();
      const hasUnseen = this.#getNotificationIds().some((id) => !seen.has(id));
      this.classList.toggle('has-unseen', hasUnseen);
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-grid-image-switcher"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-grid-image-switcher')) {
    customElements.define(
      'product-grid-image-switcher',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('change', this);
        }

        disconnectedCallback() {
          this.removeEventListener('change', this);
        }

        handleEvent(event) {
          if (event.type === 'change') {
            globalThis.clarity?.('event', 'Product Grid Image Switch');
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
